// https://home.promotigo.com/Dashboard

app = {
	debug: {
		mode: false, // on/off debug mode
		start: "pgResults", // start on specific page
		testQs: true, // On/off to debug selected qustions from list below
		questions: [2, 6, 13, 14, 15],
		email: true, // make prizeform emails unique to prevent err when testing
	},
	preloadTime: 500,
	content: {}, // Store content data for use
	competitionActive: true,
	pages: {
		current: "pgAgeGate",
		list: [], // store list of pages,
		changeDur: 2400,
		easing: "cubicBezier(0.83, 0, 0.17, 1)",
		isChanging: false,
	},
	quiz: {
		current: 0,
		total: 5,
		user: {
			smoky: 0,
			smooth: 0,
		},
		result: {
			side: "",
			percent: 0,
			loadDelay: 3000,
		},
	},
	promotigo: {
		// id: "5084aec3-bb9b-482a-b71f-cf6d5f1eca4f" // TESTING
		id: "68613d4f-c6c4-4edc-8d88-7f0d7dfaf2f3", // LIVE
	},

	init: () => {
		if (!app.debug.mode) {
			console.log = () => {}; // disable console.log when debug mode is off
			console.table = () => {};
		}

		// console.log("INIT");

		// Load content data
		jqueryJson("./js/content.json", (res) => {
			app.content = res;

			app.competitionCheck(() => {
				app.quizInit(() => {
					// Compile random quiz Q's

					app.prizesCheck(() => {
						// Get most current prize image
						app.pagesInit(() => {
							// Start the pages model

							app.bindDom(); // Add click events

							// Custom Select boxes
							// $("#pgAgeGate select").selectOrDie({
							// 	size: 5
							// });

							$("#pgAgeGate select").customSelect();

							// Scrollbars for form dropdowns
							$("#ageGate .custom-select-panel").each(
								(i, item) => {
									// console.log(item);
									new SimpleBar($(item)[0]);
								}
							);

							// Show the site when ready
							let showSite = anime({
								targets: "#viewport",
								opacity: 1,
								duration: 500,
								delay: 2000,
							});
						});
					});
				});
			});
		});
	},

	/////////////////////////////////////////
	// EVENTS
	/////////////////////////////////////////

	//:::::::::::::::::::::::::::::::::::::::
	// Global Dom Event Listeners
	//:::::::::::::::::::::::::::::::::::::::
	bindDom: () => {
		// console.log('BIND DOM');

		$("[data-changepage]").on("click", (e) => {
			// console.log($(e.target));
			let page = $(e.target).attr("data-changepage");
			app.pageChange(page);
		});

		$("#btnAgeGate").on("click", (e) => {
			e.preventDefault();
			app.formAgeCheck();
		});

		$("#btnPrizeDraw")
			.unbind("click")
			.on("click", (e) => {
				e.preventDefault();
				app.formPrizeDrawCheck();
			});

		// Dsktop hover events for quiz (clcik events applied during quiz init sequence)
		if (!("ontouchstart" in window)) {
			// check for NOT touch device
			$("[data-quizanswer]").on("mouseenter", (e) => {
				e.stopPropagation();
				let $btn = $(e.target);
				app.onAnswerHover($btn, true);
			});
		}

		$("[data-overlayopen]").on("click", (e) => {
			e.preventDefault();

			let id = $(e.target).attr("data-overlayopen");
			let pos = $(e.target).attr("data-overlaypos");
			app.overlayOpen(id, pos);
		});

		$("[data-overlayclose]").on("click", (e) => {
			e.preventDefault();
			app.overlayClose();
		});

		$("[data-overlayformreset]").on("click", (e) => {
			e.preventDefault();
			app.overlayClose();
			app.drawIsSending(false);
		});

		$("[data-termsanchor]").on("click", (e) => {
			e.preventDefault();
			let loc = $(e.target).attr("href");
			app.termsScroll(loc);
		});
		// overlay closer
	},

	//:::::::::::::::::::::::::::::::::::::::
	// Global and Specific Page closing events
	//:::::::::::::::::::::::::::::::::::::::
	bindPageClose: (id) => {
		console.log("PAGE CLOSING EVENT: " + id);
		switch (id) {
			case "pgLanding":
				app.bottlesShow(false);
				break;
			default:
		}
	},

	//:::::::::::::::::::::::::::::::::::::::
	// Global and Specific Page opening events
	//:::::::::::::::::::::::::::::::::::::::
	bindPageOpen: (id) => {
		console.log("PAGE OPENING EVENT: " + id);

		let $page = $("#" + id);

		if ($page.attr("data-quiz")) {
			// Check for quiz page
			console.log("This Is A Quiz Page!");
			app.quiz.current++; // track current quiz page
			$("#quizTracker").addClass("is-active");
			$("#quizTracker").attr("data-currquestion", app.quiz.current);
		} else {
			$("#quizTracker").removeClass("is-active");
		}

		switch (id) {
			case "pgLanding":
				app.bottlesShow(true);
				break;
			case "pgResults":
				app.quizCalcResult();
				break;
			case "pgEnterDraw":
				$("#pgEnterDraw select").customSelect();

				// Scrollbars for form dropdowns
				$("#pgEnterDraw .custom-select-panel").each((i, item) => {
					// console.log(item);
					new SimpleBar($(item)[0]);
				});
				break;
			case "pgFinish":
				app.bottlesShow(true);
				break;
			default:
		}
		// Quiz Page Functions
	},

	/////////////////////////////////////////
	// COMPETITON CHECK (prize draw activation)
	/////////////////////////////////////////

	//:::::::::::::::::::::::::::::::::::::::
	// Check if prize draw is active
	//:::::::::::::::::::::::::::::::::::::::
	competitionCheck: (callback) => {
		const compDates = app.content.comp;

		let competitionActive = false;

		let today = new Date();

		$.each(compDates, (i, item) => {
			let from = new Date(item.from);
			let to = new Date(item.to);

			if (today >= from && today <= to) competitionActive = true;
		});

		app.competitionActive = competitionActive;

		if (!competitionActive) {
			app.competitionInactive();
		}

		if (callback) callback();
	},

	//:::::::::::::::::::::::::::::::::::::::
	// Change content if prize draw is DE-Activated
	//:::::::::::::::::::::::::::::::::::::::
	competitionInactive: () => {
		$(".page-landing__copy").html(app.content.noCompLandingCopy);

		$(".page-landing__cta .btn").attr("data-changepage", "pgQuiz1");

		$('.btn[data-changepage="pgEnterDraw"]').remove();
	},

	/////////////////////////////////////////
	// PAGEING FUNCTIONS
	/////////////////////////////////////////

	//:::::::::::::::::::::::::::::::::::::::
	// pagesInit() - fetch all the page data and start paging functionality
	//:::::::::::::::::::::::::::::::::::::::
	pagesInit: (callback) => {
		console.log("Fetching pages..");

		$("div[data-page]").each((i, item) => {
			let $item = $(item);

			// Create page data object
			let page = {
				id: $item.attr("id"),
				$page: $item,
			};

			// Store page object
			app.pages.list.push(page);
		});

		// DEBUG START ON SPECIFIC PAGE
		if (app.debug.mode && app.debug.start) {
			app.pageChange(app.debug.start);
		}

		// Once pages collected and tracked...
		// app.pageOpen(app.pages.current); // open the first page

		anime.set(".page:not(#" + app.pages.current + ")", {
			translateY: "100%",
		});

		app.bindPageOpen(app.pages.current); // new page open events

		if (callback) callback();
	},

	pageOpen: (id, dir) => {
		if (!$("#" + id).length) {
			// safety check
			console.error("Couldnt find page: " + newId + " in the DoM");
			return;
		}

		console.log("Opening pg: " + id);

		let $page = $("#" + id);

		$page.removeClass("is-dnone"); // RESET PAGE..

		// Begin opening the page..

		setTimeout(() => {
			$page.addClass("is-opening");

			let start = "100%";

			if (dir == "reverse") {
				start = "-100%";
			}

			anime.set("#" + id, {
				translateY: start,
			});

			let openPage = anime({
				targets: "#" + id,
				translateY: "0%",
				duration: app.pages.changeDur,

				easing: app.pages.easing,
				begin: () => {
					app.bindPageOpen(id); // new page open events
				},
				complete: () => {
					$page.addClass("is-ready"); // use to trigger css animations for content
					app.pages.current = id; // track new current page
					app.pages.isChanging = false;
				},
			});
		}, 10);
	},

	pageClose: (id, dir) => {
		console.log("Closing pg: " + id);

		let $page = $("#" + id);
		$page.removeClass("is-ready");

		setTimeout(() => {
			$page.removeClass("is-opening"); // reset state classes
			$page.addClass("is-closing");

			let end = "-100%";

			if (dir == "reverse") {
				end = "100%";
			}

			app.screenwipe(dir);

			let closePage = anime({
				targets: "#" + id,
				translateY: end,
				duration: app.pages.changeDur,
				easing: app.pages.easing,
				begin: () => {
					app.bindPageClose(id); // new page open events
				},
				complete: () => {
					$page.addClass("is-dnone"); // hid epage form DoM
					$("#screenWipe").removeClass("is-active");
				},
			});
		}, 10);
	},

	pageChange: (newId, dir) => {
		if (app.pages.isChanging) return;
		app.pages.isChanging = true;

		if (!$("#" + newId).length) {
			// safety check
			console.error("Couldnt find page: " + newId + " in the DoM");
			return;
		}
		app.pageClose(app.pages.current, dir);
		app.pageOpen(newId, dir);
	},

	/////////////////////////////////////////
	// Overlays
	/////////////////////////////////////////
	overlayOpen: (contID, pos) => {
		let $overlay = $("#overlay");
		let $cont = $("#" + contID);

		$cont.removeClass("is-dnone");
		$overlay.removeClass("is-dnone");

		setTimeout(() => {
			let scroll = $overlay.find(".overlay__scroll");

			if (scroll) {
				$(scroll).find(".simplebar-content-wrapper").scrollTop(0);
				console.log("has scroll");
				app.overlayScroll = new SimpleBar($(scroll)[0]);

				console.log(app.overlayScroll.getScrollElement());
				if (pos) {
					app.termsScroll("#" + pos);
				}
			}
			$overlay.addClass("is-open");
		}, 10);
	},

	termsScroll: (loc) => {
		// alert(loc);

		let $scroll = $("#overlay .simplebar-content-wrapper");
		let $loc = document.querySelector(loc);

		$scroll.scrollTop(0);
		if ($(loc).offset().top > 0) {
			$scroll.scrollTop($(loc).offset().top - $scroll.offset().top - 30);
		}
	},

	overlayClose: () => {
		let $overlay = $("#overlay");
		let $cont = $(".overlay__cont");

		$overlay.removeClass("is-open");

		// Stop child animations propagating to event
		$overlay.find("*").on("transitionend", (e) => {
			e.stopPropagation();
		});

		$overlay.one("transitionend", (e) => {
			$overlay.addClass("is-dnone"); // hid epage form DoM
			$cont.addClass("is-dnone");
			// alert();
		});
	},

	screenwipe: (dir) => {
		let tl = anime.timeline({
			easing: app.pages.easing,
			duration: app.pages.changeDur,
		});

		anime.set("#screenWipe", {
			translateY: "0%",
		});

		if (dir == "reverse") {
			$("#screenWipe, .screenWipe__bar").css({
				top: "0",
				bottom: "auto",
			});

			anime.set(".screenWipe__bar", {
				translateY: "-100%",
			});

			tl.add({
				targets: "#screenWipe",
				translateY: "100%",
			});
		} else {
			$("#screenWipe, .screenWipe__bar").css({
				top: "auto",
				bottom: "0",
			});

			anime.set(".screenWipe__bar", {
				translateY: "100%",
			});

			tl.add({
				targets: "#screenWipe",
				translateY: "-100%",
			});
		}
	},

	/////////////////////////////////////////
	// FORMS and VALIDATION
	/////////////////////////////////////////

	//:::::::::::::::::::::::::::::::::::::::
	// AGE CHECK FORM
	//:::::::::::::::::::::::::::::::::::::::
	formAgeCheck: () => {
		// check all fields are filled
		let today = new Date();
		let $form = $("#ageGate");
		let $day = $('.input[for="ageGateDay"]');
		let day = $("#ageGateDay").val();
		let $month = $('.input[for="ageGateMonth"]');
		let month = $("#ageGateMonth").val();
		let $year = $('.input[for="ageGateYear"]').has("#ageGateYear");
		let year = $("#ageGateYear").val();
		let $cookies = $('.input[for="ageGateCookie"]');
		let cookies = $("#ageGateCookie").prop("checked");

		if (day && month && year && cookies) {
			// test for no missing values
			let dob = new Date(year, month - 1, day);
			let age = Math.floor((today - dob) / 31557600000);

			if (age > 18) {
				// TODO: CHANGE REQ DATE BY LOCATION?
				app.pageChange("pgLanding");
			} else {
				app.overlayOpen("errorAgeGate");
				console.error("TOO YOUNG");
			}
		} else {
			console.error("MISSING VALUE");

			// RESET VALIDATION
			$form.removeClass("is-invalid");
			$day.removeClass("is-invalid");
			$month.removeClass("is-invalid");
			$year.removeClass("is-invalid");

			// APPLY VALIDATION
			$form.addClass("is-invalid");
			if (!day) $day.addClass("is-invalid");
			if (!month) $month.addClass("is-invalid");
			if (!year) $year.addClass("is-invalid");
			if (!cookies) $cookies.addClass("is-invalid");
		}
	},

	/////////////////////////////////////////
	// Prize Funcxtions
	/////////////////////////////////////////

	//:::::::::::::::::::::::::::::::::::::::
	// app.prizesCheck() - chekc for correct rpize to display
	//:::::::::::::::::::::::::::::::::::::::
	prizesCheck: (callback) => {
		let prizes = app.content.prizes;
		console.log(prizes);
		let today = new Date();
		console.log(today);
		let thePrize;

		$.each(prizes, (i, item) => {
			let date = new Date(item.date);
			console.log(date);
			console.log(date - today);
			if (date <= today) {
				thePrize = item;
			}
		});

		let $imageMob = $("#prizesImg_mob");
		let $imageDesk = $("#prizesImg_desk");

		$imageMob.attr("src", thePrize.imgMob);
		$imageDesk.attr("src", thePrize.imgDesk);

		if (callback) callback();
	},
	/////////////////////////////////////////
	// QUIZ FUNCTIONS
	/////////////////////////////////////////

	//:::::::::::::::::::::::::::::::::::::::
	// Init Quiz - Select the questions and build the DOM
	//:::::::::::::::::::::::::::::::::::::::
	quizInit: (callback) => {
		let questionsPool = generate(5, 15); // generate random numbers
		if (app.debug.mode && app.debug.testQs) {
			questionsPool = app.debug.questions;
		}
		console.log(questionsPool);

		$.each(questionsPool, (index, item) => {
			let content = app.content.quiz[item - 1]; // get the content random number
			let $quizPage = $('[data-quiz="' + index + '"]');
			// console.log(content);

			// SETUP QUESTION AND CHOICES
			let $question = $quizPage.find("[data-quizquestion]");
			let $choices = $quizPage.find("[data-quizchoice]");
			//let $smooth = $('[data-quiz="' + index + '"] [data-quizanswer="smooth"]');
			//let $smoky = $('[data-quiz="' + index + '"] [data-quizanswer="smoky"]');

			$question.html(content.question);
			$choices.html(content.choices);
			//$smooth.html(content.smooth);
			//$smoky.html(content.smoky);

			// RANDOM CHOICE FOR BUTTONS
			let rand = Math.floor(Math.random() * 2) + 1 - 1;

			let top = "smooth";
			let bottom = "smoky";

			if (rand === 1) {
				top = "smoky";
				bottom = "smooth";
			}

			let page_id = $quizPage.attr("id");
			let mobUrl1 = content[top].bkgMob;
			let deskUrl1 = content[top].bkgDesk;
			let mobOffset1 = content[top].voffset.mob;
			let deskOffset1 = content[top].voffset.desk;
			let mobUrl2 = content[bottom].bkgMob;
			let deskUrl2 = content[bottom].bkgDesk;
			let mobOffset2 = content[bottom].voffset.mob;
			let deskOffset2 = content[bottom].voffset.desk;
			console.log(deskUrl1);

			let styleInject = `
				<style>
					#${page_id} .page__half:first-child {
						background-image: url(${mobUrl1});
						background-position: 50% ${mobOffset1};

					}
					@media screen and (min-width: 1200px) {
						#${page_id} .page__half:first-child {
							background-image: url(${deskUrl1});
							background-position: 50% ${deskOffset1};
						}
					}
					#${page_id} .page__half:last-child {
						background-image: url(${mobUrl2});
						background-position: 50% ${mobOffset2};
					}
					@media screen and (min-width: 1200px) {
						#${page_id} .page__half:last-child {
							background-image: url(${deskUrl2});
							background-position: 50% ${deskOffset2};
						}
					}

					html.mobile #${page_id} .page__half {
						background-size: 120% auto;
					}
				</style>
			`;

			// Inject the images
			$(styleInject).insertBefore($quizPage);

			let $halfTop = $("#" + page_id + " .page__half:first-child ");
			let $halfBottom = $("#" + page_id + " .page__half:last-child");

			$halfTop.attr("data-quizanswer", top);
			$halfBottom.attr("data-quizanswer", bottom);

			// Add click events
			app.quizOnClickEvents();

			if (callback) callback();
		});
	},

	quizOnClickEvents: () => {
		app.answering = false;
		$("[data-quizanswer]").one("click", (e) => {
			e.stopPropagation();

			if (app.answering) return;
			app.answering = true;

			let $btn = $(e.target);
			let answer = $btn.attr("data-quizanswer");
			app.quizAnswer($btn, answer);
		});

		$("[data-quizanswer]").css("cursor", "pointer");
	},

	//:::::::::::::::::::::::::::::::::::::::
	// app.quizAnswer($btn, answer) - user answers a question...
	//:::::::::::::::::::::::::::::::::::::::

	quizAnswer: ($btn, answer) => {
		$("#" + app.pages.current).removeClass("is-ready"); // remove interaction

		app.quiz.user[answer]++; // add to result score

		console.table(app.quiz.user);

		// animation
		let dividerDir = "100%";
		let direction = "";

		if ($btn.is(":first-child")) {
			direction = "reverse";
		}

		// Detect Reverse direction
		if ($btn.is(":last-child")) {
			dividerDir = "0%";
		}

		// HEIGHTS MUST BE SET IN THE HTML!

		let tl = anime.timeline({
			easing: app.pages.easing,
			loop: false,
			begin: () => {
				if (Detectizr.device.type == "mobile") {
					anime({
						targets:
							"#" +
							app.pages.current +
							' [data-quizanswer="' +
							answer +
							'"]',
						backgroundSize: "100% auto",
						duration: app.pages.changeDur / 2,
						// delay: app.pages.changeDur / 4,
						easing: app.pages.easing,
					});
				}
			},
			complete: () => {
				// Page Chanage
				let next = "";

				app.answering = false;

				if (app.quiz.current < app.quiz.total) {
					//if more questions...
					next = "pgQuiz" + (app.quiz.current + 1);
				} else {
					// do after last question
					next = "pgResults";
				}

				setTimeout(() => {
					app.pageChange(next, direction);
				}, 500);
			},
		});

		tl.add(
			{
				targets:
					"#" +
					app.pages.current +
					' .page__half:not([data-quizanswer="' +
					answer +
					'"])',
				height: "0%",
				duration: app.pages.changeDur / 2,
			},
			0
		)
			.add(
				{
					targets:
						"#" +
						app.pages.current +
						' [data-quizanswer="' +
						answer +
						'"]',
					height: "100%",
					duration: app.pages.changeDur / 2,
				},
				0
			)

			.add(
				{
					targets: "#" + app.pages.current + " .page__divider",
					top: dividerDir,
					duration: app.pages.changeDur / 2,
				},
				0
			)
			.add(
				{
					targets: "#" + app.pages.current + " .page__midCard",
					opacity: 0,
					duration: app.pages.changeDur / 8,
				},
				app.pages.changeDur / 4
			)
			.add(
				{
					targets: "#" + app.pages.current + " .page-quizQ__label",
					opacity: 0,
					duration: app.pages.changeDur / 8,
				},
				app.pages.changeDur / 4
			);
	},

	//:::::::::::::::::::::::::::::::::::::::
	// app.onAnswerHover($el:obj, hover:bool) - hover fx for quiz answer buttons
	//:::::::::::::::::::::::::::::::::::::::
	onAnswerHover: ($el, hover) => {
		let activeSize = "70%";
		let inactiveSize = "30%";
		let activeLabelOffset = "15vh";

		let page = "#" + app.pages.current;
		let activeBtn, inactiveBtn, activeLabel, inactiveLabel;

		if ($el.is(":first-child")) {
			activeBtn = page + " [data-quizanswer]:first-child";
			inactiveBtn = page + " [data-quizanswer]:last-child";
			activeLabel = page + " [data-quizanswer]:first-child .btn-question";
			inactiveLabel =
				page + " [data-quizanswer]:last-child .btn-question";
			dividerDir = activeSize;
		} else {
			activeBtn = page + " [data-quizanswer]:last-child";
			inactiveBtn = page + " [data-quizanswer]:first-child";
			activeLabel = page + " [data-quizanswer]:last-child .btn-question";
			inactiveLabel =
				page + " [data-quizanswer]:first-child .btn-question";
			dividerDir = inactiveSize;
			activeLabelOffset = "-15vh";
		}

		let tl = anime.timeline({
			easing: app.pages.easing,
			loop: false,
			duration: app.pages.changeDur / 2,
			begin: () => {
				$("[data-quizanswer]").off("click"); // stop click events during anmimation
				$("[data-quizanswer]").css("cursor", "default");
			},
			complete: () => {
				app.quizOnClickEvents(); // re-establish click events after animation
			},
		});

		if (hover) {
			console.log("ENTER:" + activeBtn);

			tl.add(
				{
					targets: activeBtn,
					height: activeSize,
				},
				0
			)
				.add(
					{
						targets: inactiveBtn,
						height: inactiveSize,
					},
					0
				)
				.add(
					{
						targets: activeLabel,
						translateY: activeLabelOffset,
						scale: 1.15,
						duration: app.pages.changeDur - app.pages.changeDur / 3,
					},
					0
				)
				.add(
					{
						targets: inactiveLabel,
						translateY: 0,
						scale: 1,
						duration: app.pages.changeDur - app.pages.changeDur / 3,
					},
					0
				)
				.add(
					{
						targets: page + " .page__divider",
						top: dividerDir,
					},
					0
				);
		}
	},
	//:::::::::::::::::::::::::::::::::::::::
	// app.quizCalcResult() - calculate users score
	//:::::::::::::::::::::::::::::::::::::::
	quizCalcResult: () => {
		let side = "smooth";

		let percent = "";

		if (app.quiz.user.smoky > app.quiz.user.smooth) {
			side = "smoky";
		}

		// Set background
		if (side == "smooth") {
			$("#pgResults").addClass("is-light");
		} else {
			$("#pgResults").addClass("is-dark");
		}

		app.quiz.result.side = side;

		// pick a random image formt he correct side
		let resultPool = app.content.results[side];

		let rand = generate(1, resultPool.length);

		console.log(side);
		console.log(resultPool[rand - 1]);

		let result = resultPool[rand - 1];

		// let resCopy = side + 'Copy';
		// Chnage page body copy
		// $('#resCopy').html(app.content.results[resCopy]);

		// TODO: UPDATE RESULT URSLS IN COTNENT JSON
		// setup share urls
		$("[data-facebook]").attr(
			"href",
			"https://www.facebook.com/sharer/sharer.php?u=" + result.url
		);
		$("[data-twitter]").attr(
			"href",
			"https://twitter.com/intent/tweet?url=" + result.url
		);
		$("[data-download] a").attr("href", result.imgDesk);
		$("[data-download] a").attr(
			"download",
			result.imgDesk.split("/").pop()
		);
		$("[data-download] img").attr("src", result.imgMob);

		// load image
		$("#resultImgMob").attr("src", result.imgMob);
		$("#resultImgDesk").attr("src", result.imgDesk);

		let loaded = 0;

		const onLoaded = () => {
			setTimeout(() => {
				$("#pgResults").addClass("is-resultLoaded");
			}, app.quiz.result.loadDelay);
		};

		// Load mobile img
		$("#resultImgMob").on("load", () => {
			loaded++;

			if (loaded == 2) onLoaded(); // if both loaded show content
		});

		// Load desktop img
		$("#resultImgDesk").on("load", () => {
			loaded++;

			if (loaded == 2) onLoaded(); // if both loaded show content
		});
	},

	/////////////////////////////////////////
	// app.bottlesShow() - show/hide the big bottles
	/////////////////////////////////////////
	bottlesShow: (show) => {
		// anime.set('#bottles', {
		// 	opacity: 0,
		// 	translateY:
		// });
		let $bottles = $("#bottles");

		// Show bottles
		if (show) {
			anime.set("#bottles", {
				translateY: "100%",
				opacity: 0,
			});

			$bottles.removeClass("is-dnone");

			let tl = anime.timeline({
				easing: app.pages.easing,
				loop: false,
				duration: app.pages.changeDur,
				delay: 40,
			});

			tl.add(
				{
					targets: "#bottles",
					opacity: 1,
					translateY: "0%",
				},
				0
			);

			// Hide Bottles
		} else {
			// $bottles.removeClass('is-active');

			let tl = anime.timeline({
				easing: "easeInOutCubic",
				loop: false,
				duration: app.pages.changeDur / 2 - 200,
				complete: () => {
					// REST BOTTOLS
					anime.set("#bottleLight, #bottleDark", {
						opacity: 1,
						translateX: "0%",
					});

					// RESET LAYOUT
					anime.set("#bottles", {
						translateY: "100%",
						opacity: 0,
					});
				},
			});

			tl.add(
				{
					targets: "#bottleDark",
					translateX: "-150%",
				},
				0
			)
				.add(
					{
						targets: "#bottleLight",
						translateX: "150%",
					},
					0
				)
				.add(
					{
						targets: "#bottleLight, #bottleDark",
						opacity: 0,
						duration: app.pages.changeDur / 4 - 200,
					},
					app.pages.changeDur / 4 - 200
				);
		}
	},
};

/////////////////////////////////////////
// JSON LOAD
/////////////////////////////////////////
const jqueryJson = (path, callback) => {
	$.getJSON(path, function (res) {
		callback(res);
	});
};

/////////////////////////////////////////
// OTHER HELPER FUNCTIONS
/////////////////////////////////////////
const generate = (length, total) => {
	var arr = [];
	var n;
	for (var i = 0; i < length; i++) {
		do n = Math.floor(Math.random() * total + 1);
		while (arr.indexOf(n) !== -1);

		if (length > 1) {
			arr[i] = n;
		} else {
			arr = n;
		}
	}

	return arr;
};

//////////////////////////////////////////////
//! SVG TOOLS
//////////////////////////////////////////////
// Flatten svg symbols to allow styling
svg4everybody({
	polyfill: true, // Force inlining of all symbols on all browsers
});

//////////////////////////////////////////////
// DOC READY
//////////////////////////////////////////////
$(document).ready(function () {
	app.init();
});

/////////////////////////////////////////
// TEST FORM SEND
/////////////////////////////////////////
